import { render, staticRenderFns } from "./DiscoverNoUser.vue?vue&type=template&id=584ffa79&"
import script from "./DiscoverNoUser.vue?vue&type=script&lang=js&"
export * from "./DiscoverNoUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports